import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import DatePickerFormField from '../../date-picker-form-field';
import { jsx as _jsx } from "react/jsx-runtime";

var DateInput = function DateInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      getValues = _ref$questionForm.getValues,
      errors = _ref$questionForm.formState.errors;
  return pipe(getValues(name), O.fromPredicate(function (val) {
    return val instanceof Date || val === null || typeof val === 'string';
  }), O.match(function () {
    //TODO(qlonik): Replace with LogRocket logging
    console.error('Date Question should have a Date, string or null value');
    return null;
  }, function () {
    return /*#__PURE__*/_jsx(DatePickerFormField, {
      control: control,
      name: name,
      required: required,
      error: errors[name]
    });
  }));
};

export default DateInput;